<template>
  <aside
    class="flex-shrink-0 border-r border-gray-200 flex flex-col overflow-hidden bg-white
           fixed inset-y-0 left-0 z-40 w-[85vw] max-w-[400px] shadow-xl transform transition-transform duration-300
           md:static md:z-auto md:w-[30%] md:max-w-[450px] md:transform-none md:shadow-none"
    :class="store.leftDrawerOpen.value ? 'translate-x-0' : '-translate-x-full md:translate-x-0'"
  >
    <!-- Mobile close button -->
    <div class="md:hidden flex items-center justify-between px-4 py-2 border-b border-gray-200">
      <span class="text-sm font-medium text-gray-700">Panels</span>
      <button @click="store.leftDrawerOpen.value = false" class="text-gray-500 hover:text-gray-700">
        <X :size="20" />
      </button>
    </div>

    <!-- Tabs -->
    <div class="flex border-b border-gray-200">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        @click="store.activeTab.value = tab.key"
        class="flex-1 text-sm font-medium py-2 text-center transition-colors"
        :class="store.activeTab.value === tab.key
          ? 'text-teal-700 border-b-2 border-teal-500 bg-white'
          : 'text-gray-600 hover:text-gray-800'"
      >{{ tab.label }}</button>
    </div>

    <!-- Tab content -->
    <div class="flex-1 overflow-y-auto p-4">
      <AuthorVoiceFields v-if="store.activeTab.value === 'voice'" />
      <AudienceFields v-if="store.activeTab.value === 'audience'" />
      <ContentListPanel v-if="store.activeTab.value === 'content'" />
      <PlanListPanel v-if="store.activeTab.value === 'plan'" />
      <IdeaBankPanel v-if="store.activeTab.value === 'ideas'" />
    </div>
  </aside>
</template>

<script setup>
import { inject } from 'vue'
import { X } from 'lucide-vue-next'
import AuthorVoiceFields from './AuthorVoiceFields.vue'
import AudienceFields from './AudienceFields.vue'
import ContentListPanel from './ContentListPanel.vue'
import PlanListPanel from './PlanListPanel.vue'
import IdeaBankPanel from './IdeaBankPanel.vue'

const store = inject('workbench')

const tabs = [
  { key: 'voice', label: 'Voice' },
  { key: 'audience', label: 'Project' },
  { key: 'content', label: 'Content' },
  { key: 'plan', label: 'Plan' },
  { key: 'ideas', label: 'Ideas' },
]
</script>
